// styles
import styled from 'styled-components';
import { DateIcon } from 'refactored/ui/icons';
import React, { useState } from 'react';
// styles
import { useClickOutside } from 'refactored/ui/utils';
import DatePickerCalendar from 'components/form/DatePickerCalendar';
import { useTranslation } from 'react-i18next';

const InputContainer = styled.div`
  box-sizing: border-box;

  /* Auto layout */

  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;

  /* width: 276px; */
  height: 48px;

  /* secondary / white */

  background: #ffffff;
  /* grey / 300 */

  border-width: 1px 1px 1px 4px;
  border-style: solid;
  border-color: #ccd6e0;
  border-radius: 4px;

  /* Inside auto layout */

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
  width: 100%;
  overflow: hidden;
`;

const IconContainer = styled.div`
  box-sizing: border-box;

  /* Auto layout */

  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 8px;
  gap: 10px;

  width: 48px;
  height: 48px;

  /* grey / 100 */

  background: #f2f5f8;
  /* grey / 300 */

  align-items: center;
  justify-content: center;
`;

const InputFieldContainer = styled.div`
  box-sizing: border-box;

  /* Auto layout */

  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px 12px 2px;
  gap: 12px;

  width: 114px;
  height: 48px;

  /* secondary / white */

  background: #ffffff;
  flex-grow: 1;
`;

const InputFieldInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0px;

  width: 90px;
  height: 40px;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 1;
`;

const InputLabelText = styled.div`
  width: 34px;
  height: 16px;

  /* 12px/medium */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */

  display: flex;
  align-items: center;

  /* grey / 500 */

  color: #94a6b8;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
`;
const InputValueText = styled.div`
  /* 00:00 */

  width: 90px;
  height: 24px;

  /* 16px/regular

Shipper App Default
*/
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* grey / 900 */

  color: #263340;

  /* Inside auto layout */

  /* flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0; */
  width: 100%;
`;

const Dropdown = styled.div`
  border: 1px solid green;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;

  position: absolute;
  top: 110%;
  /* left: 0; */
  right: 0;

  background: var(--white);
  /* grey / 300 */

  border: 1px solid #ccd6e0;
  border-radius: 4px;

  padding: 0px;
  /* background: pink; */
  /* border: 5px solid pink; */
  z-index: 1;
`;

const SoFormCandidateBlockDetailsInputDay = ({ inputDayData, className }) => {
  const clickRef = React.useRef();
  const { t } = useTranslation('Catalog');

  useClickOutside(clickRef, () => {
    setIsOpened(false);
  });

  const [isOpened, setIsOpened] = useState(false);

  const {
    formattedDate,
    value,
    minDate,
    handleChange,
    disableWeekends,
    disabledDays,
  } = inputDayData;

  return (
    <div className={className} ref={clickRef}>
      <InputContainer onClick={() => setIsOpened(true)}>
        <IconContainer>
          <DateIcon />
        </IconContainer>
        <InputFieldContainer>
          <InputFieldInnerContainer>
            <InputLabelText>{t('price.day')}</InputLabelText>
            <InputValueText>{formattedDate}</InputValueText>
          </InputFieldInnerContainer>
        </InputFieldContainer>
      </InputContainer>
      {isOpened && (
        <Dropdown>
          <DatePickerCalendar
            value={value}
            minDate={minDate}
            handleChange={(e) => {
              setIsOpened(false);
              if (handleChange !== undefined) handleChange(e);
            }}
            disableWeekends={disableWeekends}
            disabledDays={disabledDays}
          />
        </Dropdown>
      )}
    </div>
  );
};

export default styled(SoFormCandidateBlockDetailsInputDay)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  position: relative;

  /* height: 72px; */

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 1;
  width: 100%;
  /* border: 1px solid black; */
`;
